// extracted by css-extract-rspack-plugin
export default {"root":"aew-y3n72v9Zc1CHEFjB-","message":"_2gGlztdIgJKqUH5UMrjD11","actions":"_28SWjtrtT4WUYdiyuiz4Ut"};